import $axios from '@/utils/http'
import Base from './base'

export default class Receive extends Base {
  handleReceive ( params ) {
    return $axios.post(`${this.baseURL}/poster/grant`, params)
  }
}